import { createSelector } from 'reselect';
import { countBy, flatten, flow, map } from 'lodash/fp';

import playerPositionsSelector from './playerPositionsSelector';

const selectedPlayersSelector = createSelector(
  playerPositionsSelector,
  flow(
    map('selections'),
    flatten
  )
);

const selectionsBySideSelector = createSelector(
  selectedPlayersSelector,
  countBy('teamId')
);

export default selectionsBySideSelector;
